export function subMenu() {
    const _document = this._document;
    const _isTouch = this.isTouch;
    const header = _document.querySelector(".main-header");
    function worker(elem) {
        [...elem.querySelectorAll("li")].forEach(item => {
            if(item.querySelector(".sub-menu")) {
                item.classList.add("extended");
            }
        });
        if(_isTouch) {
            _document.addEventListener("click", event => {
                const _target = event.target;

                if(_target.classList.contains("extended")) {
                    if(!_target.classList.contains("expanded")) {
                        [..._document.querySelectorAll(".extended")].forEach(item => {
                            item.classList.remove("expanded");
                        });
                        setTimeout(() => {
                            _target.classList.add("expanded");
                        }, 100);
                    } else {
                        setTimeout(() => {
                            _target.classList.remove("expanded");
                        }, 100);
                    }
                }
            });
        } else {
            [..._document.querySelectorAll(".extended")].forEach(item => {
                item.addEventListener("mouseover", () => {
                    if(!header.classList.contains("colored")) {
                        header.classList.add("colored");
                    }
                });
                item.addEventListener("mouseout", () => {
                    if(header.classList.contains("colored")) {
                        header.classList.remove("colored");
                    }
                });
            });
        }
    }
    worker(_document.querySelector(".secondary-menu"));
    worker(_document.querySelector(".main-menu"));
}


// WEBPACK FOOTER //
// ./assets/js/modules/sub-menu.js